// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import VueAgile from 'vue-agile'
import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import {store} from './store/store';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

// Font Awesome
library.add(faCoffee);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Custom libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import "mfb/src/mfb.min.css"
import "mfb/src/mfb.min.js"
import './utils/table-resize.js'

// Custom components

import Vuebar from 'vuebar';
import vBlur from 'v-blur'
import Toasted from 'vue-toasted';
import ToggleButton from 'vue-js-toggle-button'
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import {Tabs, Tab} from 'vue-tabs-component';
import Tooltip from '@/components/tooltip/Tooltip.vue'
import CustomActions from '@/components/custom-actions/CustomActions.vue'
import ls from 'vue-ls';
import Constants from '@/utils/constants'
import Dropdown from 'hsy-vue-dropdown'
import VueDragDrop from 'vue-drag-drop';


const socketio  = require('socket.io-client');
// import socketio from 'socket.io';
import VueSocketIO from 'vue-socket.io';

export const SocketInstance = socketio(Constants.SOCKET_IO_URL);
// Vue.use(VueAgile);
Vue.use(VueResource);
Vue.use(Vuebar);
Vue.use(vBlur);
Vue.use(ClientTable);
Vue.use(ServerTable);
Vue.use(ToggleButton);
Vue.use(Toasted);
Vue.use(require('vue-script2'));
Vue.use(Dropdown);
Vue.use(VueDragDrop);
Vue.use(Datetime);

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('tooltip', Tooltip);

Vue.component('custom-actions', CustomActions);

Vue.use(Tabs);

Vue.use(VueLocalStorage);
Vue.use(VueSocketIO, SocketInstance);

// This is an interceptor for CORS requests,to send credentials
Vue.http.options.credentials = true;
Vue.http.interceptors.push((request, next) => {
    request.credentials = true;
    next((response) => {
        // We're assuming that all 401 responses caused from session expire and refreshing the application
        // Hence session is expired application will navigate to login screen
        if (response.status === 401) {
            location.reload(true);
        }
    });
});

/* eslint-disable no-new */
new Vue({
    store: store,
    el: '#app',
    router,
    template: '<App/>',
    components: {App},
    ls
})



// WEBPACK FOOTER //
// ./src/main.js